import styled from 'styled-components'
import { Button, Card } from 'antd'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'

export const ManageDepartmentContentWrapper = styled(ContentBlockWrapper)`
  padding: 20px 0 24px;
  background: transparent !important;
  box-shadow: none !important;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
`

export const ManageDepartmentContent = styled.div`
  margin-top: 10px;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
`

export const ManageDepartmentHeader = styled.div`
  .pageHeaderWrapper .pageTitle {
    font-size: 24px !important;
    font-weight: 700 !important;
    line-height: 32px !important;
    letter-spacing: 0;
  }

  .ant-space {
    gap: 10px !important;
  }

  .custom-ant-button {
    height: 38px !important;
    border-radius: 8px !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 16px !important;
    box-shadow: none !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

    .anticon {
      font-size: 15px !important;
      margin-right: 6px !important;
    }

    &:not(.ant-btn-primary) {
      background: #ffffff !important;
      border: 1px solid #e2e8f0 !important;
      color: #334155 !important;

      &:hover {
        border-color: #93c5fd !important;
        background: #f8fafc !important;
        color: #1d68a5 !important;
        box-shadow: 0 2px 8px rgba(112, 174, 251, 0.16) !important;
      }

      &:active {
        background: #eff8ff !important;
        transform: scale(0.98);
      }
    }

    &.ant-btn-primary {
      background: #1d68a5 !important;
      border-color: #1d68a5 !important;
      color: #ffffff !important;
      box-shadow: 0 2px 8px rgba(29, 104, 165, 0.2) !important;

      &:hover {
        background: #155589 !important;
        border-color: #155589 !important;
        box-shadow: 0 4px 12px rgba(29, 104, 165, 0.3) !important;
      }

      &:active {
        transform: scale(0.98);
      }
    }
  }
`

export const ManageDepartmentLayout = styled.section`
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  gap: 24px;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`

export const DepartmentNav = styled.nav`
  min-width: 0;

  @media (max-width: 767px) {
    overflow: hidden;
  }
`

export const DepartmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 78vh;
  overflow-y: auto;
  padding-right: 6px;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 9999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #cbd5e1;
  }

  @media (max-width: 767px) {
    flex-direction: row;
    overflow-x: auto;
    padding-bottom: 6px;
  }
`

export const DepartmentButton = styled(Button)`
  display: flex;
  align-items: center;
  min-height: 42px;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 400;
  padding: 0 16px;
  text-align: left;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: none;

  &:hover {
    border-color: #9cd4fc;
    background: #eff8ff;
    color: #0f172a;
    box-shadow: 0 2px 8px rgba(112, 174, 251, 0.16);

    span {
      color: #0f172a;
    }
  }

  &:focus {
    outline: none;
  }

  &.active {
    border-color: #9cd4fc;
    background: #eff8ff;
    color: #0f172a;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(112, 174, 251, 0.16);
    transform: none;

    span {
      color: #0f172a;
      font-weight: 600;
    }
  }

  span {
    display: block;
    width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.2s ease;
    font-weight: inherit;
  }

  @media (max-width: 767px) {
    flex: 0 0 auto;
    width: auto;
    max-width: 220px;
    border-radius: 8px;

    &:hover {
      transform: none;
    }
  }
`

export const DepartmentPanel = styled.main`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: calc(100vh - 180px);
  border-radius: 16px;
  background: #f6f6f6;
  border: 1px solid #e2e8f0;
  padding: 24px;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .ant-spin-nested-loading {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
  }

  .ant-spin-container {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
  }

  @media (max-width: 767px) {
    padding: 16px;
  }
`

export const DepartmentPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
`

export const DepartmentTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .count-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 6px;
    background: #eff8ff;
    color: #475569;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    white-space: nowrap;
    flex-shrink: 0;
  }
`

export const DepartmentTitle = styled.h2`
  margin: 0;
  color: #0f172a;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 18px !important;
  font-weight: 400 !important;
  line-height: 26px !important;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const DepartmentActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const DepartmentActionButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: ${styleProps => (styleProps.danger ? '#ef4444' : '#64748b')};
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  padding: 0;

  &:hover {
    color: ${styleProps => (styleProps.danger ? '#dc2626' : '#1d68a5')};
    background: ${styleProps =>
      styleProps.danger ? '#fef2f2' : '#eff8ff'};
    border-color: ${styleProps =>
      styleProps.danger ? '#fecaca' : '#9cd4fc'};
    box-shadow: 0 2px 6px
      ${styleProps =>
        styleProps.danger
          ? 'rgba(239, 68, 68, 0.12)'
          : 'rgba(112, 174, 251, 0.16)'};
  }

  &:active {
    transform: scale(0.96);
  }

  &:focus {
    outline: none;
  }
`

export const UserGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: minmax(236px, auto);
  gap: 20px 16px;
  align-content: start;
  min-height: 748px;

  @media (max-width: 1199px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    min-height: 748px;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    min-height: 0;
  }
`

export const UserCardButton = styled(Card)`
  display: flex;
  min-width: 0;
  min-height: 236px;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  cursor: pointer;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  padding: 24px 16px 20px;
  text-align: center;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-width: 0;
    padding: 0;
    text-align: center;
  }

  &:hover,
  &:focus {
    border-color: #bae6fd;
    box-shadow: 0 12px 24px -4px rgba(112, 174, 251, 0.15);
    outline: none;
    transform: translateY(-4px);

    .employee-name {
      color: #0f172a;
    }
  }

  .card-avatar {
    background: #70aefb;
    color: #ffffff;
    font-size: 26px;
    font-weight: 600;
    border: 3px solid #ffffff;
    box-shadow: 0 4px 14px rgba(112, 174, 251, 0.25);
    transition: transform 0.25s ease;
  }

  &:hover .card-avatar,
  &:focus .card-avatar {
    transform: scale(1.05);
  }
`

export const UserName = styled.div`
  width: 100%;
  margin-top: 14px;
  color: #0f172a;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  white-space: nowrap;
  transition: color 0.2s ease;
`

export const UserPosition = styled.div`
  display: inline-block;
  max-width: 90%;
  margin-top: 6px;
  padding: 2px 10px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const UserMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #f1f5f9;
  align-items: center;
  width: 100%;
`

export const UserContactRow = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 100%;
  min-width: 0;
  color: #70aefb;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .anticon {
    flex: 0 0 auto;
    font-size: 14px !important;
  }
`

export const UserContactText = styled.div`
  display: block;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 200px;
  color: #475569;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const EmptyUserWrapper = styled.div`
  padding: 32px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 240px;

  .ant-empty {
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .ant-empty-image {
      height: 44px;
      margin: 0 0 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.75;
      filter: grayscale(1);

      svg {
        width: auto;
        height: 40px;
        opacity: 0.8;
      }
    }

    .ant-empty-description {
      margin: 0;
      padding: 0;
      color: #94a3b8 !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      text-align: center;
    }
  }
`

export const DeleteIcon = styled.span`
  color: #ef4444;
`

export const DepartmentDeletePopconfirmGlobalStyle = styled.div`
  /* Global helper for department delete popconfirm */
`
